import React from 'react';
import { useSelector } from 'react-redux';
import { Globe, Key, Database, Copy } from 'lucide-react';
import { message } from 'antd';

const Endpoint = ({ instanceBasicInfo }) => {
  const isSidebarOpen = useSelector(state => state.app.isSidebarOpen);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => message.success('Copied to clipboard'))
      .catch(() => message.error('Failed to copy'));
  };

  const endpointAddress = instanceBasicInfo?.Endpoint?.Address || '-';
  const endpointPort = instanceBasicInfo?.Endpoint?.Port || '-';
  const connectionString = endpointAddress !== '-' && endpointPort !== '-' 
    ? `${instanceBasicInfo.Engine}://${endpointAddress}:${endpointPort}` 
    : '-';

  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <div className="mb-5 border-b border-gray-100 pb-4">
          <h2 className="text-lg font-semibold text-gray-900">Connection Information</h2>
          <p className="text-gray-500 text-sm mt-1">Database connection details for your applications</p>
        </div>

        <div className="space-y-6">
          {/* Endpoint Address */}
          <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
            <div className="flex items-center mb-3">
              <Globe className="w-5 h-5 text-indigo-500 mr-2" />
              <h3 className="font-medium text-gray-900">Endpoint Address</h3>
            </div>
            <div className="flex items-center justify-between">
              <div className="bg-white px-4 py-2 rounded border border-gray-200 text-gray-800 font-mono text-sm flex-grow mr-2 overflow-x-auto">
                {endpointAddress}
              </div>
              <button
                onClick={() => handleCopy(endpointAddress)}
                className="p-2 bg-indigo-50 text-indigo-600 rounded-md hover:bg-indigo-100 transition-colors duration-200"
              >
                <Copy className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Port */}
          <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
            <div className="flex items-center mb-3">
              <Key className="w-5 h-5 text-indigo-500 mr-2" />
              <h3 className="font-medium text-gray-900">Port</h3>
            </div>
            <div className="flex items-center justify-between">
              <div className="bg-white px-4 py-2 rounded border border-gray-200 text-gray-800 font-mono text-sm flex-grow mr-2">
                {endpointPort}
              </div>
              <button
                onClick={() => handleCopy(endpointPort)}
                className="p-2 bg-indigo-50 text-indigo-600 rounded-md hover:bg-indigo-100 transition-colors duration-200"
              >
                <Copy className="w-5 h-5" />
              </button>
            </div>
          </div>

          {/* Connection String */}
          <div className="bg-gray-50 p-5 rounded-lg border border-gray-200">
            <div className="flex items-center mb-3">
              <Database className="w-5 h-5 text-indigo-500 mr-2" />
              <h3 className="font-medium text-gray-900">Connection String</h3>
            </div>
            <div className="flex items-center justify-between">
              <div className="bg-white px-4 py-2 rounded border border-gray-200 text-gray-800 font-mono text-sm flex-grow mr-2 overflow-x-auto">
                {connectionString}
              </div>
              <button
                onClick={() => handleCopy(connectionString)}
                className="p-2 bg-indigo-50 text-indigo-600 rounded-md hover:bg-indigo-100 transition-colors duration-200"
              >
                <Copy className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Endpoint;